import { createContext, useContext, type ReactNode } from 'react';
import type { SvgIconComponent } from '@mui/icons-material';

export interface NavItem {
  to: string;
  label: string;
  icon: SvgIconComponent;
}

const NavItemsContext = createContext<NavItem[]>([]);

interface NavItemsProviderProps {
  items: NavItem[];
  children: ReactNode;
}

export function NavItemsProvider({ items, children }: NavItemsProviderProps) {
  return <NavItemsContext.Provider value={items}>{children}</NavItemsContext.Provider>;
}

export const useNavItems = (): NavItem[] => useContext(NavItemsContext);
